import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { submitForm } from '@/store/slices/formSlice';
import FormField from './FormField';
import TermsAndConditions from './TermsAndConditions';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Card, CardContent } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

const MultiColumnForm = ({ form, onSubmit, user }) => {
  const [formData, setFormData] = useState({});
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Group fields into rows for 2-column layout
  const groupedFields = form.fields.reduce((rows, field, index) => {
    if (index % 2 === 0) {
      rows.push([field]);
    } else {
      rows[rows.length - 1].push(field);
    }
    return rows;
  }, []);

  const handleFieldChange = (fieldId, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldId]: value
    }));
    
    // Clear error when field is updated
    if (errors[fieldId]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldId];
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    form.fields.forEach(field => {
      if (field.required && !formData[field.id]) {
        newErrors[field.id] = `${field.label} is required`;
      }
      
      // Additional validation based on field type
      if (field.type === 'email' && formData[field.id]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData[field.id])) {
          newErrors[field.id] = 'Please enter a valid email address';
        }
      }
      
      if (field.type === 'phone' && formData[field.id]) {
        const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        if (!phoneRegex.test(formData[field.id])) {
          newErrors[field.id] = 'Please enter a valid phone number';
        }
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!acceptedTerms) {
      setErrors({ terms: 'You must accept the terms and conditions' });
      return;
    }
    
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-6">
            {groupedFields.map((row, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {row.map((field) => (
                  <div 
                    key={field.id} 
                    className={field.column_span === 2 ? 'md:col-span-2' : ''}
                  >
                    <FormField
                      field={field}
                      value={formData[field.id] || ''}
                      onChange={handleFieldChange}
                      error={errors[field.id]}
                      user={user}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <TermsAndConditions 
        content={form.terms_content}
        accepted={acceptedTerms}
        onAcceptChange={setAcceptedTerms}
        error={errors.terms}
      />
      
      <div className="flex space-x-4">
        <Button type="submit" className="w-full md:w-auto">
          Submit Form
        </Button>
        <Button type="button" variant="outline" onClick={() => window.history.back()}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default MultiColumnForm;